
export function mediaOrientation(thisitem, thismediawidth, thismediaheight) {
  console.log("mediaOrientation()");
  console.log("thisitem", thisitem);
  console.log("thismediawidth", thismediawidth);
  console.log("thismediaheight", thismediaheight);

  var thiswidth = thisitem.clientWidth,
      thisheight = thisitem.clientHeight,
      thiswidthtoheightratio = (thiswidth / thisheight),
      thismedia = thisitem.querySelector('img, video');

  if (thismediawidth === undefined) {
    thismediawidth = thismedia.clientWidth;
    thismediaheight = thismedia.clientHeight;
  }

  var thismediawidthtoheightratio = (thismediawidth / thismediaheight);

  thisitem.removeAttribute("item-ratio");
  thismedia.removeAttribute("itemmedia-ratio");

  thisitem.setAttribute("item-ratio", thiswidthtoheightratio);
  thismedia.setAttribute("itemmedia-ratio", thismediawidthtoheightratio);

  // Remove classes
  thisitem.classList.remove("square-item", "image-larger-than-item", "vertical-item", "horizontal-item", "ratio-equal", "media-larger-than-item");
  thismedia.classList.remove("square-media", "vertical-media", "horizontal-media");

  if (thiswidth == thisheight) {
    thisitem.classList.add("square-item");
    if (thiswidthtoheightratio > thismediawidthtoheightratio) {
      thisitem.classList.add("media-larger-than-item");
    }
  } else if (thiswidth < thisheight) {
    thisitem.classList.add("vertical-item");
    if (thiswidthtoheightratio < thismediawidthtoheightratio) {
      thisitem.classList.add("media-larger-than-item");
    }
  } else if (thiswidth > thisheight) {
    thisitem.classList.add("horizontal-item");
    if (thiswidthtoheightratio < thismediawidthtoheightratio) {
      thisitem.classList.add("media-larger-than-item");
    }
  }

  if (thismediawidth == thismediaheight) {
    thismedia.classList.add("square-media");
  } else if (thismediawidth < thismediaheight) {
    thismedia.classList.add("vertical-media");
  } else if (thismediawidth > thismediaheight) {
    thismedia.classList.add("horizontal-media");
  }
}
